import { newEntity } from 'entities-next/common'
import { compact } from 'lodash'

import { User, UserRole, UserStatus } from './user.types'

export function getUserName({ firstName, lastName }: Pick<User, 'firstName' | 'lastName'>) {
  const names = compact([firstName, lastName])
  return names.join(' ').trim()
}

export function newUser(): User {
  return {
    ...newEntity(),
    email: '',
    firstName: '',
    lastName: '',
    role: UserRole.member,
    status: UserStatus.active,
    highlighted: false,
    askForOnboarding: false,
    admin: false,
    corporateId: 1,
  }
}
